import axios from 'axios'
import Message from 'element-ui/lib/message'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api/admin',
  timeout: 20000
})

service.interceptors.request.use(config => {
  const token = localStorage.getItem('adminToken')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

service.interceptors.response.use(
  response => response.data,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('adminToken')
      if (window.location.hash !== '#/login') window.location.hash = '#/login'
    }
    const message = error.response && error.response.data ? error.response.data.message : '请求失败'
    Message.error(message)
    return Promise.reject(error)
  }
)

export default service
